import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Percent, Megaphone, MapPin } from "lucide-react";

const PERKS = [
  { icon: Percent, label: "Wholesale pricing", desc: "Tiered bulk rates that protect your margin" },
  { icon: Megaphone, label: "Marketing support", desc: "Co-branded campaign assets & product training" },
  { icon: MapPin, label: "Territory focus", desc: "Priority allocation in your region" },
];

export default function DistributorBand() {
  return (
    <section data-testid="distributor-band" className="py-20 md:py-28 relative overflow-hidden" style={{ background: "linear-gradient(180deg, #1A1F27, #0E1116)" }}>
      <div className="sunset-ambient" style={{ top: "-300px", left: "-200px", opacity: 0.4 }} />
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative z-10 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          <div className="eyebrow">Distributor &amp; wholesale</div>
          <h2 className="display mt-4" style={{ fontSize: "clamp(2rem, 4.5vw, 4rem)", color: "#FCF6EA" }}>
            Stock the iron your customers <span className="sunset-text">keep asking about</span>.
          </h2>
          <div className="mt-8 grid sm:grid-cols-3 gap-6">
            {PERKS.map((p) => {
              const I = p.icon;
              return (
                <div key={p.label}>
                  <I size={20} color="var(--sun-amber)" strokeWidth={1.7} />
                  <div className="mt-3 text-sm font-medium" style={{ color: "#FCF6EA" }}>{p.label}</div>
                  <div className="mt-1 text-xs leading-relaxed" style={{ color: "rgba(252,246,234,0.6)" }}>{p.desc}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="md:col-span-5 flex flex-col gap-3 md:items-end">
          <Link to="/distributors" data-testid="distributor-band-apply" className="btn-brand justify-center w-full md:w-auto">
            Apply to distribute <ArrowRight size={16} />
          </Link>
          <Link
            to="/contact"
            data-testid="distributor-band-contact"
            className="btn-outline justify-center w-full md:w-auto"
            style={{ color: "#F2F0EA", borderColor: "rgba(255,255,255,0.3)" }}
          >
            Contact sales
          </Link>
        </div>
      </div>
    </section>
  );
}
